export default function Contact({
  officePhone,
  nonEmergency,
  emEmail,
  lieutenant,
  lieutenantEmail,
}) {
  return (
    <div className="flex flex-col text-lg">
      <div className="text-lime-600 font-bold mb-1">CONTACT INFORMATION</div>
      <ContactItem label="Office Phone:" value={officePhone} hrefType="tel" />
      <ContactItem label="Non-emergencies:" value={nonEmergency} hrefType="tel" />
      <ContactItem label="Email:" value={emEmail} hrefType="email" />
      <div className="w-72 mt-5">
        <p className="flex items-center space-x-1">
          <span>Lieutenant {lieutenant}</span>
        </p>
      </div>
      <ContactItem label="Email" value={lieutenantEmail} hrefType="email" />
    </div>
  );
}

function ContactItem({ label, value, hrefType }) {
  const hrefPrefix = hrefType === 'email' ? 'mailto:' : 'tel:';

  return (
    <div className="flex items-center">
      <div className="mr-2">
        {label}{' '}
        <a
          href={`${hrefPrefix}${value}`}
          className="text-black hover:text-gray-600 no-underline font-bold"
        >
          {value}
        </a>
      </div>
    </div>
  );
}
